<template>
  <div>
    address
  </div>
</template>

<script>
export default {
  name: 'address'
}
</script>

<style>

</style>